import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React, { FC } from 'react';

import { palette } from 'src/styles';

import AlertIcon from '../images/alert';
import Checkmark from '../images/checkmark-greenV2.svg';
import InformationIcon from '../images/info-blue.svg';
import useStyles from './styles';

export enum AlertTypes {
  danger = 'danger',
  informational = 'informational',
  success = 'success',
  warning = 'warning',
}
interface GetIconProps {
  type: `${AlertTypes}`;
}

const getIcon: FC<GetIconProps> = ({ type = AlertTypes.informational }) => {
  switch (type) {
    case AlertTypes.danger:
      return <AlertIcon color="var(--ds-color-danger, #e11d48)" />;
    case AlertTypes.warning:
      return <AlertIcon />;
    case AlertTypes.success:
      return <img alt="success icon" src={Checkmark} />;
    default:
      return <img alt="info icon" src={InformationIcon} />;
  }
};

export interface AlertProps {
  children: JSX.Element;
  className?: string;
  fullWidth: boolean;
  type: `${AlertTypes}`;
}

export const Alert: FC<AlertProps> = ({ children, className, fullWidth = false, type = AlertTypes.informational }) => {
  // Prefer the theme over the `src/styles` palette module. That module is
  // resolved once at import and never passes through `ThemeProvider`, so an app
  // that maps the palette — recruiter-ui onto Ripple — could not reach this
  // component and the banner kept painting raw FDS values.
  //
  // The module is still the fallback, for a render with no provider above it:
  // `useTheme` returns Material-UI's own default theme there, which carries
  // none of the custom palette keys. Several suites render a component
  // containing this one without wrapping it.
  const theme = useTheme();
  const classes = useStyles({
    background:
      theme.palette.alertTypesBackgroundColors?.[type] ??
      palette.alertTypesBackgroundColors[type],
    fullWidth,
  });
  const Icon = getIcon({ type });
  return (
    <Grid className={classNames(classes.container, className)}>
      <Grid alignItems="center" className={classes.content} container justify="center" wrap="nowrap">
        {Icon}
        <Typography className={classes.message} color="textPrimary" display="inline" variant="body2">
          {children}
        </Typography>
      </Grid>
    </Grid>
  );
};
